import React,{useState,useEffect} from 'react'

function AfradeTahTSarparasti({storageName,title , state , setState}) {
   const [data,setData] =useState("")
   useEffect(()=>{
     const items = JSON.parse(localStorage.getItem(storageName));
     if (items) {
       setData(items)
       console.log(items);
     }
   },[])



const onChangeHandler =(e)=>{
    let name = e.target.name;
    let value = e.target.value;
    const data = {...state , [name]:value}
    setState(data)
}
  return (
           <div className="mt-8 flex flex-col">
                <div className="w-full flex justify-center items-center border border-solid border-gray-400 p-2">
                <span className="font-bold text-gray-700">
                         {title}
                </span>
             
            </div>
            <div className="w-full flex justify-between items-center border border-solid border-gray-400  ">
<div className="w-full flex justify-center items-center   p-2">
کارمند یا کارگر
</div>
<div className="w-full flex justify-center items-center   p-2">
<input name="کارمند یا کارگر"  onChange={onChangeHandler} type="number"
min={0}
                  className="w-full border-solid border-2 border-gray-200 rounded-sm px-3 py-[4px]"
                  placeholder={data["کارمند یا کارگر"]?data["کارمند یا کارگر"] :"تعداد افراد تحت سرپرستی را بنویسید"} />
</div>
            </div>
            <div className="w-full flex justify-between items-center border border-solid border-gray-400  ">
<div className="w-full flex justify-center items-center   p-2">
   کمک کارشناس
</div>
<div className="w-full flex justify-center items-center   p-2">
<input  name="کمک کارشناس" onChange={onChangeHandler}  type="number"
min={0}
                  className="w-full border-solid border-2 border-gray-200 rounded-sm px-3 py-[4px]"
                  placeholder={data["کمک کارشناس"]?data["کمک کارشناس"] :"تعداد افراد تحت سرپرستی را بنویسید"} />
</div>
            </div>
            <div className="w-full flex justify-between items-center border border-solid border-gray-400  ">
<div className="w-full flex justify-center items-center   p-2">
   کارشناس
</div>
<div className="w-full flex justify-center items-center   p-2">
<input  name="کارشناس" onChange={onChangeHandler}  type="number"
min={0}
                  className="w-full border-solid border-2 border-gray-200 rounded-sm px-3 py-[4px]"
                  placeholder={data["کارشناس"]?data["کارشناس"] :"تعداد افراد تحت سرپرستی را بنویسید"} />
</div>
            </div>
            <div className="w-full flex justify-between items-center border border-solid border-gray-400  ">
<div className="w-full flex justify-center items-center   p-2">
   کارشناس ارشد
</div>
<div className="w-full flex justify-center items-center   p-2">
<input  name="کارشناس ارشد" onChange={onChangeHandler} type="number"
min={0}
                  className="w-full border-solid border-2 border-gray-200 rounded-sm px-3 py-[4px]"
                  placeholder={data["کارشناس ارشد"]?data["کارشناس ارشد"] :"تعداد افراد تحت سرپرستی را بنویسید"} />
</div>
            </div>
            <div className="w-full flex justify-between items-center border border-solid border-gray-400  ">
<div  className="w-full flex justify-center items-center   p-2">
 سطوح  مدیریتی
</div>
<div className="w-full flex justify-center items-center   p-2">
<input  name="سطوح مدیریتی" onChange={onChangeHandler} type="number"
min={0}
                  className="w-full border-solid border-2 border-gray-200 rounded-sm px-3 py-[4px]"
                  placeholder={data["سطوح مدیریتی"]?data["سطوح مدیریتی"] :"تعداد افراد تحت سرپرستی را بنویسید"}/>
</div>
            </div>
            </div>


  )
}

export default AfradeTahTSarparasti